"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(data, config) {
  return "<h".concat(data.level, ">").concat(data.text, "</h").concat(data.level, ">");
};

exports["default"] = _default;